import './lp-accession.scss'

const Accession = () => {
  const cards = [
    {
      title: '1. Baixe o app FGTS e cadastre-se',
      text: 'Selecionar a opção "Cadastre-se" para criar uma senha de acesso'
    },
    {
      title: '2. Autorize a opção Saque-Aniverário',
      text: 'Clique em ”Saque-Aniversário do FGTS”, e realize a adesão.'
    },
    {
      title: '3. Autorize banco a consultar seu FGTS',
      text: 'Clique em "Autorizar bancos a consultarem seu FGTS" e então selecione o ”Itaú Consignado SA”.'
    },
    {
      title: '4. Pronto, simule o seu saque antecipado',
      text: 'Se estiver de acordo, finalize sua contratação.'
    }
  ]

  return (
    <div className="accession">
      <div className="accession__container">
        <h2 className="accession__title">
          Adesão ao <span className="--orange">Saque-Aniversário do FGTS</span>
        </h2>
        <div className="accession__cards">
          {cards.map(({ title, text }) => {
            return (
              <div key={title} className="accession__card">
                <p className="accession__card-title">{title}</p>
                <p className="accession__card-text">{text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Accession
